import { render, staticRenderFns } from "./PublicPartnersRegistrationView.vue?vue&type=template&id=d32115dc"
import script from "./PublicPartnersRegistrationView.vue?vue&type=script&lang=js"
export * from "./PublicPartnersRegistrationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports